document.write('<script language="javascript" src="/js/global/nav.js"></script>');
document.write('<script type="text/javascript" src="/assetroot/js/global/quickmenu.js"></script>');

document.write('<link href="/assetroot/css/global/top_menu.css" rel="stylesheet" type="text/css" media="screen" />');
document.write('<link href="/assetroot/css/global/print.css" rel="stylesheet" type="text/css" media="print" />');
document.write('<!--[if IE ]><script type="text/javascript"  src="/assetroot/js/global/fix_eolas.js"  defer="defer"></script><![endif]-->');
document.write('<!--[if IE 5]><script type="text/javascript"  src="/assetroot/js/global/fix_ie5.js"  defer="defer"></script><![endif]-->');

// include code to pick up the correct CSS for NS
// ----------------------------------------------
document.write('<link href="/assetroot/css/global/global.css" rel="stylesheet" type="text/css">');
document.write('<link href="/assetroot/css/global/princessNN.css" rel="stylesheet" type="text/css">');
document.write('<style type="text/css">@import url(/assetroot/css/global/princess.css)\;</style>');

document.write('<!--[if IE]>  <link href="/assetroot/css/global/ie.css" rel="stylesheet" type="text/css" media="screen" /> <![endif]-->');
document.write('<!--[if IE 5.0]>  <link href="/assetroot/css/global/ie5.css" rel="stylesheet" type="text/css" media="screen" /> <![endif]-->');

// begin code for top-banner
// ------------------------
var isLogin = false;
var nameToDisplay = null;
var srcURL = document.location.href;
var re=/\%/g;

// To capture where the user is coming from, and use it to redirect back
var locationOfsrcURL = srcURL.indexOf("=http");

if (locationOfsrcURL != -1) {
	srcURL = (srcURL.substr(locationOfsrcURL + 1));
} else {
	srcURL = escape(srcURL.replace(re, "##"));
}

function printTAHeader(bookingEngineId, regionId){
    document.write( '  <div id="header-container">' );
    document.write( '      <div id="header">' );    
	document.write( '        <div class="float"><a href="' + getWWWUrl(getUrl()) + 'index.html" title="Go to Home Page"><img src="/images/global/header_'+bookingEngineId+'_'+regionId+'.gif" alt="Princess Cruises Logo" /></a></div>' );		
    document.write( '      </div>' );
    document.write( '  </div>' );
    document.write( '  <div id="no-navigation"></div>' );
    document.write( '  <div style="clear:both"></div>' );
}

function printPromoBookFooter(bEngineId,countryCode,helpDeskNumber){
	document.write('<br>');
	document.write('<div id="footer">');
	document.write('  <ul>');	
	//if(bEngineId == 'PCUC')
		//document.write('    <li class="noLinkBg"><a href="javascript:openFooterWindow(\''+ getBookUrl(getUrl()) + 'BookingSystem/jsp/tnc/terms_conditions.jsp#Graduation_Cruise_Course'+'\')"; title="Legal">Legal</a></li>');	
	//else
		document.write('    <li class="noLinkBg"><a href="javascript:openFooterWindow(\''+ getWWWUrl(getUrl()) + 'legal/passage_contract/passage_contract_'+bEngineId+'.jsp?con='+countryCode+'\')"; title="Legal">Legal</a></li>');	
	document.write('  </ul>');
	document.write('</div>');
	document.write('<div id="copyRight" style="text-transform: none">');
	document.write('  <p> For assistance please call the Help Desk at '+helpDeskNumber+'</p>');
	document.write('</div>');	
	document.write('<br>');
}

function getMixedCaseName(nameToDisplay) {
	var properName = nameToDisplay;
    if(nameToDisplay != "undefined" && nameToDisplay != "" && nameToDisplay.length > 2) {
		var re 			= /\s/gi;
		var nameArray 	= nameToDisplay.split(re);
		properName  = "";
		for(i = 0; i < nameArray.length; i++) {
			var upper	= nameArray[i].substring(0,1).toUpperCase();
			var lower	= "";
			if(nameArray[i].length > 1) {
				lower	= nameArray[i].substring(1).toLowerCase();
			}
			properName += ( (i+1) == nameArray.length ) ? (upper + lower) : (upper + lower) + " ";
		}
		properName = getMixedCaseForDashSeperatedName(properName);
    }
    return properName;
}

function doSubmitSearch() {
   if((NEWSEARCH_FORM["sp-q"].value !='SEARCH')&&(NEWSEARCH_FORM["sp-q"].value !='')){
   	document.NEWSEARCH_FORM.submit();
   }
   else{
   	alert("Please enter at least one keyword to be searched.");
   	 NEWSEARCH_FORM["sp-q"].focus();
   	 return false;
   }
}


// to display the message in IE
function showMesg(str,divIdName) {
	var collection = document.getElementsByTagName('DIV');
	for(iLoop=0;iLoop<collection.length;++iLoop) {
		var idName = collection[iLoop].getAttribute('id');
		if(idName==divIdName) {
			collection[iLoop].innerHTML=str;
		}
	}
}

// This is for ticket (#SAVA-6PXVDF) - The Word after '-'
// in the second name is to be displayed as Mixed case.
function getMixedCaseForDashSeperatedName(name){
	var regEx = /-/g;
	var varArray = name.split(regEx);
	var newName = "";

  	if(varArray.length > 1){
		newName = varArray[0];
        for(i = 1; i < varArray.length; i++) {
      	   var upper = trim(varArray[i]).substring(0,1).toUpperCase();
           var lower = trim(varArray[i]).substring(1);
           newName += "-" + upper + lower;
    	}
    	return newName;
    }
	return name;
}

